import React, { FC, useState } from 'react';
import { useWatch } from 'react-hook-form';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';
import { FormDatePicker } from '../../../../components/date-picker/index';
import { DropDown } from '../../../../components/dropdown/index';
import { FormInput } from '../../../../components/input/index';
import { useFormat, useLocale } from '../../../../hooks/index';
import { StakeholderCombobox } from '../components/index';
import { ChildrenFormProps } from '../modals.types';
import { FormSchema, stepOne as stepOneFormSchema } from '../modals.validation';

export type StepOneProps = ChildrenFormProps;

export const StepOne: FC<StepOneProps> = ({
  handleCloseModal,
  nextFormStep,
  control,
  setFormData,
  companyId,
  lockMode,
  filedState,
  isLoading,
}) => {
  const { messagesLocale } = useLocale();
  const [isOpenCalendar, setOpenCalendar] = useState(false);
  const { stepOne } = useWatch<FormSchema>({ control });
  const { format } = useFormat();
  const { success } = stepOneFormSchema.safeParse(stepOne);

  const isValid = success && !filedState('stepOne').invalid;

  stepOne;

  return (
    <>
      <div className="invisible-y-scroll flex h-full flex-col gap-4 rounded-b-xl border-b border-gray-300 bg-white p-6 pt-0">
        <StakeholderCombobox companyId={companyId} control={control} />
        <FormInput
          control={control}
          currencySign
          maxDecimalPlaces={2}
          name="stepOne.investment"
          numberOnly
          placeholder={<AppFormattedMessage id="INVESTMENT" />}
          shouldFormatNumber
        />

        <FormDatePicker
          calendar={{ toDate: new Date() }}
          inputValue={stepOne?.issueDate ? format(stepOne?.issueDate, 'dd/MM/yyyy') : ''}
          inputWrapperClassName="w-full"
          isDefaultOpenCalendar={isOpenCalendar}
          onSelect={(date) => {
            setFormData('stepOne.issueDate', date);
            setOpenCalendar(false);
          }}
          placeholder={<AppFormattedMessage id="ISSUE_DATE" />}
          value={stepOne?.issueDate}
        />
        <DropDown
          answer={messagesLocale['SAFE_EXPLANATION']}
          className="rounded-lg bg-gray-50"
          question={<AppFormattedMessage id="WHAT_IS_SAFE" />}
        />
      </div>

      <div className="flex h-9 w-full justify-between gap-3 px-6">
        <Button
          className="w-fit bg-transparent px-4 py-[6px] text-sm font-[450] text-gray-700"
          onClick={handleCloseModal}
          styleType="NONE"
          type="button"
        >
          <AppFormattedMessage id="CANCEL" />
        </Button>
        <div className="flex gap-3">
          <Button
            className="h-full w-fit px-4 py-[6px] text-sm font-[550] text-white"
            disabled={!isValid}
            isLoading={isLoading}
            onClick={nextFormStep}
            type="button"
          >
            {lockMode ? <AppFormattedMessage id="UPDATE" /> : <AppFormattedMessage id="NEXT" />}
          </Button>
        </div>
      </div>
    </>
  );
};
